export default "__VITE_ASSET__CYHljsAz__"